import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { Button, Grid, InputAdornment, SvgIcon } from "@mui/material";
import { useEffect, useState } from "react";

import {
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg6,
  texto,
  useLoaders,
  useMapComponent,
} from "@/shared";
import { IconBtnModalMapComponent } from "@/shared/components/erp";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomCircularPorgress,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  SampleCheckbox,
  SampleTable,
  SingleIconButton,
  TabTextLabel,
} from "@/shared/components/ui";
import { AlertSeverityEnum, OrdenTrabajo } from "@/shared/interfaces";
import { useUiConfirmModalStore, useUiStore } from "@/store/ui";
import GlobeEuropeAfricaIcon from "@heroicons/react/24/solid/GlobeEuropeAfricaIcon";
import { Naps, PuertoNap } from "@/shared/interfaces";
// import RenderFotosEntradaSalida from "./RenderFotosEntradaSalida";
import { UseFormReturn } from "react-hook-form";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useColumnsInstalacionesOT } from "../../hooks";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { useUpdateOrdenTrabajo } from "@/shared/actions/erp";
import { useAuthStore } from "@/store/auth";
import { queryClient } from "@/shared/query-client/query-client";
import { toast } from "react-toastify";

export type OTDeralleInstallTecnicoFormTabProps = {
  //form: UseFormReturn<SaveFormDataInstallTecAsig, any>;
  form: UseFormReturn<any>;
  errors: any;
  shrink: boolean;
  coords: string;
  ordenTrabajo: OrdenTrabajo;
  isOnlyView?: boolean;

  canDragMarker?: boolean;
  canRuler?: boolean;
};

const OTDetalleInstallTecnicoFormTab: React.FC<
  OTDeralleInstallTecnicoFormTabProps
> = ({
  form,
  errors,
  shrink,
  coords,
  ordenTrabajo,
  isOnlyView = false,
  canDragMarker = false,
  canRuler = false,
}) => {
  ///* local state -----------------------
  const [canChangeNap, setCanChangeNap] = useState(false);
  const [isSetAll, setIsSetAll] = useState(false);
  const [
    openModalModificacionesCoordenadas,
    setOpenModalModificacionesCoordenadas,
  ] = useState(false);
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen,
  );

  const { columnsHistorialCambiosCoordenadas } = useColumnsInstalacionesOT();
  ///* global state -----------------------
  const setAlert = useUiStore((s) => s.setAlert);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const user = useAuthStore((s) => s.user);

  ///* form -----------------------
  const watchedRawNap = form.watch("rawNap") as Naps;
  const watchedPort = form.watch("puerto");
  const watchedCoords = form.watch("coordenadas");

  const onChangeMarker = () => {
    if (isOnlyView) return;
    if (!isSetAll) return;

    form.reset({
      ...form.getValues(),
      nap: "",
      puerto: "",
    });
    setCanChangeNap(true);
  };

  // map ------------------------
  const {
    Map,
    latLng,
    setLatLng,
    isLoadingNapsByCity: isLoadingNaps,
    isRefetchingNapsByCity: isRefetchingNaps,
    napsByCity,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: "", // replaced by coordenadasCliente
    distanciaNapKey: "distancia",
    // coordenadasCliente: coords || '',
    // enabledFetchNaps: !!coords,
    coordenadasCliente: watchedCoords || "",
    enabledFetchNaps: !!watchedCoords,
    onChangeMarker,
  });

  ///* actions ---------------
  // // ya no se solicita cambio de pueto, lo hace el mismo tecnico & activacion
  const { mutateAsync: updateOTDataAsync } = useUpdateOrdenTrabajo<
    Pick<
      OrdenTrabajo,
      "coordenadas" | "historial_cambios_coordenadas" | "reubicacion_cliente"
    >
  >({
    enableRedirect: false,
  });

  ///* effects ---------------
  useEffect(() => {
    if (isLoadingNaps || isRefetchingNaps || !ordenTrabajo || isSetAll) return;

    form.reset({
      ...form.getValues(),
      nap: ordenTrabajo?.nap || "",
      puerto: ordenTrabajo?.puerto || "",
      distancia: ordenTrabajo?.distancia || "",
    });
    setIsSetAll(true);
  }, [isLoadingNaps, ordenTrabajo]);

  useLoaders(isLoadingNaps || isRefetchingNaps || !ordenTrabajo);

  return (
    <>
      {/* <Grid {...gridSizeMdLg12} container item>
        <Typography variant="h5">FOTOS DE TÉCNICO</Typography>
      </Grid>
      <RenderFotosEntradaSalida ordenTrabajo={ordenTrabajo} showFotosEntrada={true}/>
      <RenderFotosEntradaSalida ordenTrabajo={ordenTrabajo} showFotosSalida={true}/>
      <Grid {...gridSizeMdLg12} container item>
        <hr style={{width:"100%"}}/>
      </Grid> */}

      {/* ------------- Bobina y Cable ------------- */}
      <TabTextLabel text="Bobina y Detalle Cable" pb="10px" pt="10px" />
      <>
        {/* <CustomTextField
          label="Código Bobina"
          name="codigo_bobina"
          control={form.control}
          defaultValue={form.getValues().codigo_bobina || ""}
          error={undefined}
          helperText={undefined}
          // disabled={isOnlyView}
        /> */}
        <CustomTextField
          name="splitter"
          label="Splitter"
          control={form.control}
          defaultValue={form.getValues().splitter || ""}
          error={errors.splitter}
          helperText={errors.splitter?.message || ""}
          size={gridSizeMdLg6}
          required={false}
          // disabled={isOnlyView}
        />
        <CustomTextField
          name="manga"
          label="Manga"
          control={form.control}
          defaultValue={form.getValues().manga || ""}
          error={errors.manga}
          helperText={errors.manga?.message || ""}
          size={gridSizeMdLg6}
          required={false}
          // disabled={isOnlyView}
        />
        <CustomTextField
          name="color_hilo"
          label="Color Hilo"
          control={form.control}
          defaultValue={form.getValues().color_hilo || ""}
          error={errors.color_hilo}
          helperText={errors.color_hilo?.message || ""}
          size={gridSizeMdLg6}
          required={false}
          // disabled={isOnlyView}
        />
        <CustomTextField
          name="num_hilo"
          label="Número Hilo"
          control={form.control}
          defaultValue={form.getValues().num_hilo || ""}
          error={errors.num_hilo}
          helperText={errors.num_hilo?.message || ""}
          size={gridSizeMdLg6}
          required={false}
          // disabled={isOnlyView}
        />
      </>

      {/* ------------- NAP y Detalle Activacion ------------- */}
      <TabTextLabel text="NAP Y DETALLES ACTIVACIÓN" pt={1} pb={1} />
      <>
        <Grid container item spacing={2} justifyContent={"center"}>
          <CustomAlertCard
            alertTitle="Recomendación"
            alertMessage={texto.verifique_coordenadas_tecnico}
            bgColorAlert="YELLOW"
            alertColor="warning"
          />
        </Grid>
        <Grid item xs={12} container spacing={2} alignItems="center">
          <Grid item xs={9} md={8}>
            <CustomTextField
              type="coordenada"
              control={form.control}
              name="coordenadas"
              defaultValue={form.getValues().coordenadas || ""}
              size={gridSize}
              label="Coordenadas del Cliente"
              error={errors.coordenadas}
              startAdornment={
                <InputAdornment position="start">
                  <SvgIcon fontSize="small">
                    <GlobeEuropeAfricaIcon />
                  </SvgIcon>
                </InputAdornment>
              }
              helperText={errors.coordenadas?.message}
              onChangeValue={(e, v) => {
                // if (isOnlyView) return;

                if (v) {
                  let s = e.split(",");
                  setLatLng({ lat: s[0], lng: s[1] });
                  setCurrentCoordenadas(e);
                }

                form.reset({
                  ...form.getValues(),
                  nap: "",
                  puerto: "",
                });
                setCanChangeNap(true);
              }}
              // disabled={isOnlyView}
            />
          </Grid>
          <Grid item xs={3} md={1}>
            <IconBtnModalMapComponent
              coords={`${latLng.lat},${latLng.lng}` || `${coords}` || ""}
              btnColor="info"
              showCustomMap
              customMap={
                <Map
                  coordenadas={latLng}
                  napsByCity={napsByCity || []}
                  setLatLng={setLatLng}
                  canDragMarker={canDragMarker}
                  canRuler={canRuler}
                />
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "Cambiar Ubicación de Cliente",
                  subtitle: `Al cambiar la ubicación se perderán los cambios realizados en la orden. ¿Desea continuar?`,
                  onConfirm: () => {
                    const TIME_OUT_OT = 3000;
                    queryClient.invalidateQueries({
                      queryKey: [
                        "orden-trabajo",
                        ordenTrabajo?.id_orden_trabajo,
                      ],
                    });
                    setIsGlobalLoading(true);
                    setTimeout(() => {
                      if (
                        form.watch("estado_navegacion_contrato") === "ACTIVO"
                      ) {
                        toast.error(
                          "El servicio del cliente fue activado, comuníquese con ACTIVACIONES para coordinar el cambio de ubicación",
                        );
                        setConfirmDialogIsOpen(false);
                        setIsGlobalLoading(false);
                        return;
                      }
                      setConfirmDialogIsOpen(false);
                      const updateDataCoordenadas =
                        ordenTrabajo?.historial_cambios_coordenadas
                          ? [...ordenTrabajo?.historial_cambios_coordenadas]
                          : [];
                      updateDataCoordenadas.push({
                        usuario: user?.username || "",
                        fecha_cambio: new Date().toISOString(),
                        coordenada_anterior: ordenTrabajo?.coordenadas || "",
                        coordenada_nueva: `${latLng.lat},${latLng.lng}`,
                      });
                      updateOTDataAsync(
                        {
                          id: ordenTrabajo?.id_orden_trabajo,
                          data: {
                            coordenadas: `${latLng.lat},${latLng.lng}`,
                            historial_cambios_coordenadas:
                              updateDataCoordenadas,
                            reubicacion_cliente: true,
                          },
                        },
                        {
                          onSuccess: () =>
                            queryClient.invalidateQueries({
                              queryKey: [
                                "orden-trabajo",
                                ordenTrabajo?.id_orden_trabajo,
                              ],
                            }),
                        },
                      );
                      setIsGlobalLoading(false);
                    }, TIME_OUT_OT);
                  },
                  onClose: () => {
                    setConfirmDialogIsOpen(false);
                  },
                  confirmTextBtn: "SI",
                  cancelTextBtn: "NO",
                });
              }}
              fullWidth
              sx={{ fontSize: 12 }}
            >
              Actualizar Coordenadas
            </Button>
          </Grid>
        </Grid>
      </>
      {ordenTrabajo?.historial_cambios_coordenadas?.length > 0 && (
        <Grid {...gridSizeMdLg12} container item spacing={2}>
          <Grid item {...gridSizeMdLg12}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenModalModificacionesCoordenadas(true)}
              fullWidth
            >
              Revisar Modificaciones a Coordenadas
            </Button>
          </Grid>
        </Grid>
      )}

      <>
        {isLoadingNaps || isRefetchingNaps ? (
          <Grid
            item
            container
            xs={12}
            justifyContent="center"
            alignItems="center"
            my={2}
          >
            <CustomCircularPorgress />
          </Grid>
        ) : (
          <Grid item container xs={12} alignItems="center" spacing={2}>
            <Grid item xs={12} md={6}>
              <CustomAutocomplete<Naps>
                label="NAP"
                name="nap"
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={
                  form.getValues()?.nap_data_nombre ||
                  form.getValues()?.nap_data?.nombre ||
                  form.getValues().nap ||
                  ""
                }
                // options
                options={napsByCity || []}
                isLoadingData={isLoadingNaps}
                // validation
                control={form.control}
                error={errors.nap}
                helperText={errors.nap?.message}
                size={gridSize}
                disabled={!canChangeNap || isOnlyView}
                disableClearable
                onChangeRawValue={(nap) => {
                  if (!nap) return;
                  form.reset({
                    ...form.getValues(),
                    rawNap: nap,
                    puerto: "",
                    distancia: nap?.distancia?.toString() || "",
                  });
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} container alignItems="center">
              <Grid item xs={12} md={isOnlyView ? 12 : 11}>
                {!canChangeNap ? (
                  <CustomTextFieldNoForm
                    label="Puerto"
                    value={watchedPort || ""}
                    disabled
                    size={gridSize}
                  />
                ) : (
                  <>
                    <CustomAutocomplete<PuertoNap>
                      label="Puerto"
                      name="puerto"
                      // options
                      options={
                        (watchedRawNap?.puertos?.filter(
                          (puerto) =>
                            !puerto?.estado ||
                            puerto?.puerto.toString() ===
                              ordenTrabajo?.puerto?.toString(),
                        ) as PuertoNap[]) || []
                      }
                      valueKey="puerto"
                      actualValueKey="puerto"
                      defaultValue={ordenTrabajo?.puerto?.toString() || ""}
                      isLoadingData={false}
                      // validation
                      control={form.control}
                      error={errors.puerto}
                      helperText={errors.puerto?.message}
                      size={gridSize}
                      disableClearable
                    />
                  </>
                )}
              </Grid>
              {isOnlyView ? null : (
                <Grid item xs={12} md={1}>
                  <SingleIconButton
                    startIcon={<ChangeCircleIcon />}
                    color={!canChangeNap ? "primary" : "warning"}
                    label={canChangeNap ? "Cancelar" : "Cambiar NAP/Puerto"}
                    onClick={() => {
                      if (isOnlyView) {
                        setAlert(
                          true,
                          "No puedes cambiar el NAP/Puerto en modo vista",
                          AlertSeverityEnum.info,
                        );
                        return;
                      }

                      // if cancel set puerto to default
                      if (canChangeNap) {
                        form.reset({
                          ...form.getValues(),
                          puerto: ordenTrabajo?.puerto?.toString() || "",
                          distancia: ordenTrabajo?.distancia || "",
                          nap: ordenTrabajo?.nap?.toString() || "",
                          rawNap: ordenTrabajo?.nap_data || {},
                          coordenadas: ordenTrabajo?.coordenadas || "",
                        });

                        setCurrentCoordenadas(ordenTrabajo?.coordenadas || "");
                      }

                      setCanChangeNap(canChangeNap ? false : !canChangeNap);
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        )}

        {/* <CustomNumberTextField
          label="Distancia a la NAP"
          name="distancia"
          //register={form.register('distancia')}
          error={errors.distancia}
          helperText={errors.distancia?.message}
          shrink={shrink}
          control={form.control}
          defaultValue={form.getValues().distancia || ""}
          endAdornment={<InputAdornment position="end">metros</InputAdornment>}
          disabled
        /> */}

        {/* ----- Datos ----- */}
        <>
          <CustomTextField
            name="pppoe"
            label="PPPoE"
            control={form.control}
            defaultValue={form.getValues().ipv4_actual || ""}
            error={false}
            helperText={false}
            shrink={shrink}
            disabled={true}
            size={gridSizeMdLg6}
          />
          <CustomTextField
            name="ipv4_actual"
            label="IPv4"
            control={form.control}
            defaultValue={form.getValues().ipv4_actual || ""}
            error={false}
            helperText={false}
            shrink={shrink}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextField
            name="ssid"
            label="SSID"
            type="none"
            control={form.control}
            defaultValue={form.getValues().ssid || ""}
            error={errors?.ssid}
            helperText={errors?.ssid?.message || ""}
            size={gridSizeMdLg6}
          />
          <CustomTextField
            name="password_wifi"
            label="Password WiFi"
            type="none"
            control={form.control}
            defaultValue={form.getValues().password_wifi || ""}
            error={errors?.password_wifi}
            helperText={errors?.password_wifi?.message || ""}
            size={gridSizeMdLg6}
          />
          {/* <CustomTextField
            name="ipv6_actual"
            label="IPv6"
            control={form.control}
            defaultValue={form.getValues().ipv6_actual || ""}
            error={form.formState.errors.ipv6_actual}
            helperText={form.formState.errors.ipv6_actual?.message || ""}
            shrink={shrink}
            disabled
            size={gridSizeMdLg6}
          /> */}
          {/* <CustomTextField
            name="pppoe"
            label="PPPoE"
            control={form.control}
            defaultValue={form.getValues().pppoe || ""}
            error={form.formState.errors.pppoe}
            helperText={form.formState.errors.pppoe?.message || ""}
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextField
            name="pppassword"
            label="PPPassword"
            control={form.control}
            defaultValue={form.getValues().pppassword || ""}
            error={form.formState.errors.pppassword}
            helperText={form.formState.errors.pppassword?.message || ""}
            size={gridSizeMdLg6}
            disabled
          /> */}
          {/* <CustomTextFieldNoForm
            label="Router AC"
            value={ordenTrabajo?.es_router_ac ? 'SÍ' : 'NO'}
            disabled
            size={gridSizeMdLg6}
          /> */}

          {/* -------- otros -------- */}
          <CustomTextField
            name="test_5g"
            label="Test 5G"
            control={form.control}
            defaultValue={form.getValues().test_5g || ""}
            error={errors.test_5g}
            helperText={errors.test_5g?.message || ""}
            required={true}
            // disabled={isOnlyView}
          />

          <CustomNumberTextField
            name="potencia_dbm"
            label="Potencia NAP DBM (negativo)"
            control={form.control}
            defaultValue={form.getValues().potencia_dbm || ""}
            error={errors.potencia_dbm}
            helperText={errors.potencia_dbm?.message || ""}
            size={gridSizeMdLg6}
            startAdornment={<span>-</span>}
            required={true}
            // disabled={isOnlyView}
          />
          <CustomNumberTextField
            name="potencia_ont"
            label="Potencia ONT (negativo)"
            control={form.control}
            defaultValue={form.getValues().potencia_ont || ""}
            error={errors.potencia_ont}
            helperText={errors.potencia_ont?.message || ""}
            size={gridSizeMdLg6}
            startAdornment={<span>-</span>}
            required={true}
            // disabled={isOnlyView}
          />
          {/* <CustomTextField
            name="olt"
            label="OLT"
            control={form.control}
            defaultValue={form.getValues()?.olt_data?.nombre || form.getValues().olt || ""}
            error={errors.olt}
            helperText={errors.olt?.message || ""}
            disabled
          /> */}
          <CustomTextFieldNoForm
            label="OLT"
            value={
              form.getValues()?.olt_data?.nombre ||
              "No se pudo recuperar la OLT"
            }
            disabled
          />
          <CustomAutocompleteArrString
            label="Puntos de Red Instalados"
            name="puntos_red_instalados"
            control={form.control}
            error={errors?.puntos_red_instalados}
            helperText={errors?.puntos_red_instalados?.message}
            isLoadingData={false}
            options={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
            defaultValue={form.getValues()?.puntos_red_instalados || "0"}
            size={gridSizeMdLg6}
          />
          <CustomAutocompleteArrString
            label="Puntos de Red No Instalados"
            name="puntos_red_no_instalados"
            control={form.control}
            error={errors?.puntos_red_no_instalados}
            helperText={errors?.puntos_red_no_instalados?.message}
            isLoadingData={false}
            options={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
            defaultValue={form.getValues()?.puntos_red_no_instalados || "0"}
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Routers Adicionales Instalados"
            value={form.getValues()?.routers_adicionales_instalados || "0"}
            size={gridSizeMdLg12}
            disabled
          />

          <SampleCheckbox
            label="Tiene conexión a tierra"
            name="es_conexion_tierra"
            control={form.control}
            defaultValue={!!form.getValues().es_conexion_tierra}
            size={gridSizeMdLg6}
            sxChecbox={{ pb: 2 }}
            // disabled={isOnlyView}
          />
          <SampleCheckbox
            label="Tiene regulador"
            name="es_regulador"
            control={form.control}
            defaultValue={!!form.getValues().es_regulador}
            size={gridSizeMdLg6}
            sxChecbox={{ pb: 2 }}
            // disabled={isOnlyView}
          />

          {/* -------- ubicacion equipos -------- */}
          {/* <CustomTextArea
            name="ubicacion_equipo_ac"
            required={false}
            label="Ubicación Equipo AC"
            control={form.control}
            defaultValue={form.getValues().ubicacion_equipo_ac || ""}
            error={errors.ubicacion_equipo_ac}
            helperText={errors.ubicacion_equipo_ac?.message || ""}
            // disabled={isOnlyView}
          /> */}
          {/* <CustomTextArea
            name="ubicacion_ont"
            label="Ubicación ONT"
            required={false}
            control={form.control}
            defaultValue={form.getValues().ubicacion_ont || ""}
            error={errors.ubicacion_ont}
            helperText={errors.ubicacion_ont?.message || ""}
            // disabled={isOnlyView}
          /> */}

          <CustomTextArea
            label="Observación Activación"
            name="observacion_activacion"
            control={form.control}
            defaultValue={form.getValues().observacion_activacion || ""}
            error={errors.observacion_activacion}
            helperText={errors.observacion_activacion?.message || ""}
            disabled
          />
        </>
      </>
      {openModalModificacionesCoordenadas && (
        <ScrollableDialogProps
          open={openModalModificacionesCoordenadas}
          title="Historial de Modificaciones de Coordenadas"
          cancelTextBtn="Cerrar"
          confirmVariantBtn="outlined"
          showConfirmBtn={false}
          // actions
          onClose={() => {
            setOpenModalModificacionesCoordenadas(false);
          }}
          // content
          minWidth="42%"
          contentNode={
            <>
              <Grid container {...gridSizeMdLg12}>
                <SampleTable<any>
                  columns={columnsHistorialCambiosCoordenadas}
                  data={ordenTrabajo?.historial_cambios_coordenadas || []}
                  maxHeight={300}
                />
              </Grid>
            </>
          }
        />
      )}
    </>
  );
};

export default OTDetalleInstallTecnicoFormTab;
